// Sends LinkedIn addresses to "Continue with LinkedIn" instead of a password,
// Google or a magic link.
//
// The LinkedIn pilot promised that LinkedIn's Okta is the only way in, but the
// password, invite and reset screens still let a linkedin.com address set a
// password (seen 10-08, from pre-SSO invite links). These screens now hide
// every other method for those addresses.
//
// This is the visible half only. The Supabase anon key is public, so the
// enforcing half has to live in bonni-backend's auth hooks.
//
// Mirrors bonni-backend's requiresLinkedInSignIn: exact domain match on the
// part after the last "@", lowercased. Subdomains don't match.

export type LinkedInSsoRouting = {
  enabled: boolean;
  domains: readonly string[];
};

export function parseLinkedInSsoDomains(value: string | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map((domain) => domain.trim().toLowerCase())
    .filter((domain) => domain.length > 0);
}

export function getEmailDomain(email: string): string {
  const at = email.lastIndexOf('@');
  return at === -1 ? '' : email.slice(at + 1).trim().toLowerCase();
}

export function requiresLinkedInSso(email: string | null | undefined, routing: LinkedInSsoRouting): boolean {
  if (!routing.enabled || typeof email !== 'string') return false;
  const domain = getEmailDomain(email);
  return Boolean(domain) && routing.domains.includes(domain);
}

/**
 * Pre-fills the address on Okta's screen. Supabase passes `queryParams` on to
 * the provider's authorize URL. If the hint is dropped along the way, the
 * person just types their address at Okta.
 */
export function linkedInLoginHintParams(email: string | null | undefined): Record<string, string> | undefined {
  const hint = typeof email === 'string' ? email.trim().toLowerCase() : '';
  return hint.includes('@') ? { login_hint: hint } : undefined;
}
